import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import currentPatientIdSelector from "@/redux/slice/auth/selectors/currentPatientId";
import { selectPatientById } from "@/redux/slice/auth/selectors/patientDetails";

const selectRoot = (state: RootState): RootState => state;

const selectCurrentPatientId = (state: RootState): string => currentPatientIdSelector(state);

export default createDraftSafeSelector([selectRoot, selectCurrentPatientId], (state, currentPatientId) =>
  selectPatientById(state, currentPatientId)
);
